"use client"

import { Play } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PlayIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PlayIcon = component(Icon)({ as: Play })
